import { createActionTypes } from 'utils/action/actionTypes';

export const SEND_OTP = createActionTypes('SEND_OTP');
export const VERIFY_OTP = createActionTypes('VERIFY_OTP');
export const RESEND_OTP = createActionTypes('RESEND_OTP');
